// Helper function to get applicant display name
export const getApplicantDisplayName = (applicant, castingCall) => {
  if (castingCall.call_type === 'creator') {
    return applicant.display_name || applicant.username || 'Unknown Creator';
  } else {
    if (applicant.first_name && applicant.last_name) {
      return `${applicant.first_name} ${applicant.last_name}`;
    }
    return applicant.email || 'Unknown User';
  }
};

export const getOrganizerTypeIcon = (linkType) => {
  const icons = {
    deliverables: 'Assignment',
    brief: 'Folder',
    shared: 'Share',
    default: 'Folder'
  };
  return icons[linkType] || icons.default;
};

export const getOrganizerTypeColor = (linkType) => {
  const colors = {
    deliverables: 'primary',
    brief: 'secondary',
    shared: 'info',
    default: 'default'
  };
  return colors[linkType] || colors.default;
};
export const calculateMetrics = (castingCall) => {
  if (!castingCall) return null;

  const totalApplicants = castingCall.applicants?.length || 0;
  const isSelected = castingCall.is_selected || false;
  const budget = parseFloat(castingCall.budget || 0);
  
  // ✅ Calculate assigned payouts from deliverables_scope
  let assignedPayouts = 0;
  if (castingCall.deliverables_scope?.payout_assignments) {
    assignedPayouts = Object.values(castingCall.deliverables_scope.payout_assignments)
      .reduce((sum, amount) => sum + parseFloat(amount || 0), 0);
  }
  
  const remainingBudget = budget - assignedPayouts;

  return {
    totalApplicants,
    isSelected,
    budget,
    assignedPayouts,
    remainingBudget,
    organizerCount: castingCall.organizers?.length || 0,
  };
};

// ✅ NEW: Get collaborator-specific metrics
export const getCollaboratorMetrics = (castingCall, currentUser) => {
  if (!castingCall || !currentUser) return null;

  // Find current user's application
  const applicant = castingCall.applicants?.find(app => {
    if (castingCall.call_type === 'creator') {
      return app.username === currentUser.username;
    } else {
      return app.id === currentUser.id;
    }
  });

  // Get assigned payout
  let assignedPayout = 0;
  if (castingCall.deliverables_scope?.payout_assignments) {
    const key = castingCall.call_type === 'creator' 
      ? applicant?.username 
      : applicant?.id?.toString();
    assignedPayout = parseFloat(castingCall.deliverables_scope.payout_assignments[key] || 0);
  }

  // Calculate checklist completion
  const allChecklistItems = castingCall.organizers?.flatMap(org => 
    org.checklist_items || []
  ) || [];
  
  const completedItems = allChecklistItems.filter(item => item.completed).length;
  const totalItems = allChecklistItems.length;
  const completionPercentage = totalItems > 0 ? (completedItems / totalItems) * 100 : 0;

  // Get accessible organizers
  const accessibleOrganizers = castingCall.organizers?.filter(org => 
    org.can_access
  ) || [];

  return {
    applicant,
    assignedPayout,
    completedItems,
    totalItems,
    completionPercentage,
    accessibleOrganizers,
  };
};